'use client'

import * as React from 'react'
import Link from 'next/link'

import { useLocale } from './hooks/use-locale'
import { cn } from './lib/utils'

interface LocalizedLinkProps extends React.ComponentProps<typeof Link> {
  locale?: string | false
  isClient?: boolean
  disabled?: boolean
  onClick?: any
}

const LocalizedLink = ({
  href,
  disabled = false,
  onClick,
  ...props
}: LocalizedLinkProps) => {
  const { locale } = useLocale()
  const [isClient, setIsClient] = React.useState(false)

  React.useEffect(() => {
    setIsClient(props?.isClient ?? true)
  }, [])

  const hrefString = typeof href === 'string' ? href : ''

  const isExternal =
    hrefString.startsWith('http://') ||
    hrefString.startsWith('https://') ||
    hrefString.startsWith('//') ||
    hrefString.startsWith('www.')

  let prefixedHref = href

  if (typeof href === 'string') {
    if (isExternal) {
      if (hrefString.startsWith('www.')) {
        prefixedHref = `https://${hrefString}`
      } else {
        prefixedHref = href
      }
    } else {
      prefixedHref = `/${locale}${href}`
    }
  }

  // Render a non-clickable span if disabled
  if (disabled) {
    return (
      <span
        className={cn(
          props.className,
          'cursor-not-allowed text-gray-400 hover:border-none hover:text-gray-400',
        )}
      >
        {props.children}
      </span>
    )
  }

  return <Link onClick={onClick} href={prefixedHref} {...props} />
}

export { LocalizedLink }
